import { IProductDetail, receiverFitTypes } from '../models/product-detail';
import * as CON from '../components/common/constants';
import { CartItemTypes } from '../components/common/constants';

export const getReceiverFit = (
    country: string,
    productDetailState: IProductDetail
): string[] => {
    //consider initializing variable here and setting it equal to the result of any of these paths
    if (country === CON.FR && productDetailState.isCros) {
        if (
            [CartItemTypes.BteOnly, CartItemTypes.BteWithEarmold].includes(
                productDetailState!.cartItemTypeId!
            )
        ) {
            return [receiverFitTypes.standard];
        } else if (
            [
                CartItemTypes.RicWithAp,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.RicWithStockReceiver,
            ].includes(productDetailState!.cartItemTypeId!)
        ) {
            return [receiverFitTypes.standard, receiverFitTypes.ap];
        }
    } else if (country === CON.DE) {
        if (
            [
                CartItemTypes.BteOnly,
                CartItemTypes.RicWithStockReceiver,
            ].includes(productDetailState!.cartItemTypeId!)
        ) {
            return [receiverFitTypes.standard];
        }
    } else {
        if (
            [CartItemTypes.BteOnly, CartItemTypes.BteWithEarmold].includes(
                productDetailState!.cartItemTypeId!
            )
        ) {
            return [receiverFitTypes.standard, receiverFitTypes.earmold];
        } else if (
            [
                CartItemTypes.RicWithStockReceiver,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.RicWithAp,
            ].includes(productDetailState!.cartItemTypeId!)
        ) {
            return [
                receiverFitTypes.standard,
                receiverFitTypes.earmold,
                receiverFitTypes.ap,
            ];
        } else {
            return [];
        }
    }
    return [];
};
export const getCustomCaseName = (x: string) => {
    if (x === 'Absolute Power') {
        return 'Custom_Cased/AP';
    } else return x.replace(' ', '_');
};
